import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Button, Dialog } from "@mui/material";
import { Colors } from "../../Assets/Styles/Colors";
import { Images } from "../../Assets/Images/Images";
import { ErrorToaster, SuccessToaster } from "../../Components/Toaster/Toaster";
import moment from "moment";
import { jwtDecode } from "jwt-decode";
import { ErrorHandler } from "../../Utils/ErrorHandler";
import { useAuth } from "../../Context/UseContext";
import AccountSettingServices from "../../Api/AccountSettingServices/AccountSettingServices.index";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";

const AnalogClock = () => {
  const [time, setTime] = useState(new Date());
  const [checkInTime, setCheckInTime] = useState(null);
  const [checkOutTime, setCheckOutTime] = useState(null);
  const [checkInLocation, setCheckInLocation] = useState(null);
  const [checkOutLocation, setCheckOutLocation] = useState(null);
  const [attendanceStatus, setAttendanceStatus] = useState(null);
  const [employeeDetail, setEmployeeDetail] = useState("");
  const [showDeviceCheckModal, setShowDeviceCheckModal] = useState(false);
  const [checkoutEnabled, setCheckoutEnabled] = useState(false);
  const [disableAttendanceButton, setDisableAttendanceButton] = useState(false);

  const { user, updateProfile } = useAuth();

  // console.log(isBrowser, isMobile);

  const decodedToken = jwtDecode(user.token);
  const userIdFromToken = decodedToken.id;

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime(new Date());
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);
  const localTime = new Date(time.toLocaleString("en-US"));
  const formattedDate = localTime.toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  const formattedTime = localTime.toLocaleTimeString("en-US");

  const getLocation = (callback) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // alert("Location fetched successfully");
          const { latitude, longitude } = position.coords;
          callback({ latitude, longitude });
        },
        (error) => {
          // alert("Errorrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr");

          console.error("Error getting location:", error);
          callback(null);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
      callback(null);
    }
  };

  // const handleCheckIn = async () => {
   
  //     getLocation(async (location) => {
  //       if (location) {
  //         const obj = {
  //           status: "checkin",
  //           latitude: location.latitude.toString(),
  //           longitude: location.longitude.toString(),
  //           // latitude: "24.8654569113495",
  //           // longitude:"67.0788548668361",
  //         };
  //         console.log(obj);
  //         if (!isMobile) {
  //           setShowDeviceCheckModal(true); 
  //           return; 
  //         }
  //         try {
  //           const result = await AccountSettingServices.markAttendance(obj);
  //           SuccessToaster(result?.message);
  //           getLogStatus();
            
  //         } catch (error) {
  //           ErrorToaster(error || "Error during check-in");
  //         }
  //       } else {
  //         ErrorToaster(
  //           "Location not available. Please enable location services."
  //         );
  //       }
  //     });
    
  // };

  //   const handleCheckOut = async () => {
  //     if (!isMobile) {
  //       setShowDeviceCheckModal(true); 
  //       return; 
  //     }
  //     if (attendanceStatus?.attendanceLog[0]?.check_out ||  checkoutEnabled) {
  //       console.log("Check error")
  //       return; 
  //     }
    
  //       getLocation(async (location) => {
  //         if (location) {
    
  //           const obj = {
            
  //             status: "checkout",
              
  //             latitude: location.latitude.toString(),
  //             longitude: location.longitude.toString(),
  //             // latitude: "24.8654569113495",
  //             // longitude:"67.0788548668361",
            
  //           };
            
  //           try {
  //             const result = await AccountSettingServices.markAttendance(obj);
  //             console.log(result, "message");
  //             SuccessToaster(result?.message);
  //             getLogStatus();
  //           } catch (error) {
  //             // alert("Check error1" ,error)
  //             ErrorToaster(error || "Error during check-out");
  //           }
  //         } else {
  //           ErrorToaster(
  //             "Location not available. Please enable location services."
  //           );
  //         }
  //       });
  //     // }
  //   };

  const handleCheckIn = async () => {
    if (disableAttendanceButton) return; // prevent double click
    setDisableAttendanceButton(true); // disable for 1 minute
  
    getLocation(async (location) => {
      if (location) {
        if (!isMobile) {
          setShowDeviceCheckModal(true);
          setDisableAttendanceButton(false); // re-enable in case of device block
          return;
        }
  
        const obj = {
          status: "checkin",
          latitude: location.latitude.toString(),
          longitude: location.longitude.toString(),
        };
  
        try {
          const result = await AccountSettingServices.markAttendance(obj);
          SuccessToaster(result?.message);
          getLogStatus();
  
          // Disable button for 1 minute
          setTimeout(() => {
            setDisableAttendanceButton(false);
          }, 60000);
        } catch (error) {
          setDisableAttendanceButton(false); // re-enable in case of error
          ErrorToaster(error || "Error during check-in");
        }
      } else {
        setDisableAttendanceButton(false);
        ErrorToaster("Location not available. Please enable location services.");
      }
    });
  };
  const handleCheckOut = async () => {
    if (disableAttendanceButton) return;
    setDisableAttendanceButton(true);
  
    if (!isMobile) {
      setShowDeviceCheckModal(true);
      setDisableAttendanceButton(false);
      return;
    }
  
    if (attendanceStatus?.attendanceLog[0]?.check_out || checkoutEnabled) {
      setDisableAttendanceButton(false);
      return;
    }
  
    getLocation(async (location) => {
      if (location) {
        const obj = {
          status: "checkout",
          latitude: location.latitude.toString(),
          longitude: location.longitude.toString(),
        };
  
        try {
          const result = await AccountSettingServices.markAttendance(obj);
          SuccessToaster(result?.message);
          getLogStatus();
  
          setTimeout(() => {
            setDisableAttendanceButton(false);
          }, 60000);
        } catch (error) {
          setDisableAttendanceButton(false);
          ErrorToaster(error || "Error during check-out");
        }
      } else {
        setDisableAttendanceButton(false);
        ErrorToaster("Location not available. Please enable location services.");
      }
    });
  };
    

  const getLogStatus = async () => {
    try {
      const result = await AccountSettingServices.checkAttendanceStatus();
      setAttendanceStatus(result?.data);
      const checkInMinutes = result?.data?.attendanceLog[0]?.check_in; 

      if (typeof checkInMinutes === "number") {
        const now = moment();
        const currentMinutes = now.hours() * 60 + now.minutes();

        if (checkInMinutes === currentMinutes) {
          setCheckoutEnabled(true);

          setTimeout(() => {
            setCheckoutEnabled(false);
          }, 60000);
        }
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };


  useEffect(() => {
    getLogStatus();
   
  }, []);
 

  
  console.log(checkoutEnabled, "checkoutEnabled");
  
  return (
    <>
      <Grid
        container
        alignItems="center"
        sx={{ width: { xs: "87%", sm: "100%" }, margin: "0 auto" }}
      >
        <Grid
          item
          md={
            checkInTime ||
            employeeDetail.currentStatus === "checkout" ||
            employeeDetail?.time_sheet?.checkin !== ""
              ? 7
              : 12
          }
          sm={12}
          xs={12}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{ mt: 11 }}
          >
            <Box
              sx={{
                width: { xs: "300px", sm: "80%" },
                bgcolor: Colors.dashboardBgColor,
                borderRadius: "20px",
                boxShadow: "0px 8px 16px rgba(0,0,0,0.2)",
                p: 3,
                position: "relative",
              }}
            >
              <Typography
                variant="h5"
                align="center"
                marginBottom="10px"
                sx={{ color: Colors.primary, fontFamily: "Poppins" }}
              >
                {formattedDate} <br />
                {formattedTime}
              </Typography>

              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                mt={6}
                mb={2}
              >
                <svg
                  width="200"
                  height="200"
                  viewBox="0 0 100 100"
                  className="clock-face"
                >
                  <circle
                    cx="50"
                    cy="50"
                    r="48"
                    stroke="#e0e0e0"
                    strokeWidth="2"
                    fill="none"
                  />
                  <line
                    x1="50"
                    y1="50"
                    x2="50"
                    y2="30"
                    stroke="black"
                    strokeWidth="3"
                    strokeLinecap="round"
                    transform={`rotate(${
                      localTime.getHours() * 30 + localTime.getMinutes() / 2
                    } 50 50)`} // Hour hand
                  />
                  <line
                    x1="50"
                    y1="50"
                    x2="50"
                    y2="20"
                    stroke="#424242"
                    strokeWidth="2"
                    strokeLinecap="round"
                    transform={`rotate(${localTime.getMinutes() * 6} 50 50)`} // Minute hand
                  />
                  <line
                    x1="50"
                    y1="50"
                    x2="50"
                    y2="15"
                    stroke={Colors.primary}
                    strokeWidth="1"
                    strokeLinecap="round"
                    transform={`rotate(${localTime.getSeconds() * 6} 50 50)`} // Second hand
                  />
                </svg>
              </Box>

              <Box
  align="center"
  sx={{
    mt: 3,
    p: "7px",
    background: Colors.primary,
    color: Colors.white,
    borderRadius: "13px",
    // cursor: "pointer", 
  }}

  onClick={() => {
    attendanceStatus?.attendanceLog[0]?.check_in ? handleCheckOut() : handleCheckIn()
  }}
>
  {attendanceStatus?.attendanceLog[0]?.check_in ? (
    <Button
      variant="contained"
      disabled={
        attendanceStatus?.attendanceLog[0]?.check_out  || isBrowser ||  checkoutEnabled
      }
      // onClick={handleCheckOut} 
      sx={{
        backgroundColor: Colors.primary,
        "&.Mui-disabled": {
          backgroundColor: "transparent !important",
        },
        ":hover": {
          backgroundColor: Colors.primary,
          boxShadow: "none",
        },
        color: Colors.white,
        boxShadow: "none",
        width:'100%',
        fontFamily: "Poppins",
      }}
    >
      Check Out
    </Button>
  ) : (
    <Button
      variant="contained"
      disabled={!isMobile}
      // onClick={handleCheckIn}
      sx={{
        backgroundColor: Colors.primary,
        ":hover": {
          backgroundColor: Colors.primary,
          boxShadow: "none",
        },
        "&.Mui-disabled": {
          backgroundColor: "transparent !important",
        },
        color: Colors.white,
        boxShadow: "none",
        width:'100%',
        fontFamily: "Poppins",
      }}
    >
      Check In
    </Button>
  )}
</Box>

            </Box>
          </Box>
        </Grid>

        {/* Display Check In/Out Times */}
        <Grid
          item
          md={5}
          sm={12}
          xs={12}
          sx={{ mt: 4 }}
          // md={checkInTime || (employeeDetail.currentStatus === "checkout" && checkInTime) || employeeDetail?.time_sheet?.checkin !== "" ? 5 : 12} sm={12} xs={12} sx={{ mt: 4 }}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{ my: { md: 0, xs: 3 } }}
          >
            <Grid
              container
              spacing={2}
              sx={{ width: { md: "87%", sm: "87%", xs: "351px" } ,marginLeft:"0px !important" }}
            >
              {/* {attendanceStatus?.attendanceLog?.length > 0 ? ( */}
                <Grid container spacing={2}>
                  {attendanceStatus?.attendanceLog[0]?.check_in && (
                    <Grid item xs={12} md={12}>
                      <Box
                        sx={{
                          bgcolor: Colors.dashboardBgColor,
                          borderRadius: "20px",
                          boxShadow: "0px 8px 16px rgba(0,0,0,0.2)",
                          p: 3,
                        }}
                      >
                        <Box
                          sx={{
                            py: 1,
                            display: "flex",
                            alignItems: "center",
                            gap: "20px",
                          }}
                        >
                          <Box>
                            <img
                              width="60px"
                              src={Images.jobPendingDashboard}
                              alt="Job Pending"
                            />
                          </Box>
                          <Box sx={{ width: "100%" }}>
                            <Typography
                              variant={"body2"}
                              sx={{ color: Colors.black, fontWeight: 600 }}
                            >
                              Check In Time
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "23px",
                                fontWeight: "bold",
                                mt: "3px",
                              }}
                            >
                              {moment
                                .utc()
                                .startOf("day")
                                .add(
                                  attendanceStatus?.attendanceLog[0]?.check_in,
                                  "minutes"
                                )
                                .format("hh:mm A")}
                              {/* {moment(attendanceStatus?.attendanceLog[0]?.check_in).format("hh:mm:ss A")} */}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Grid>
                  )}

                  {attendanceStatus?.attendanceLog[0]?.check_out && (
                    <Grid item xs={12} md={12} sx={{paddingBottom:8}}>
                      <Box
                        sx={{
                          bgcolor: Colors.dashboardBgColor,
                          borderRadius: "20px",
                          boxShadow: "0px 8px 16px rgba(0,0,0,0.2)",
                          p: 3,
                        }}
                      >
                        <Box
                          sx={{
                            py: 1,
                            display: "flex",
                            alignItems: "center",
                            gap: "20px",
                          }}
                        >
                          <Box>
                            <img
                              width="60px"
                              src={Images.jobPendingDashboard}
                              alt="Job Pending"
                            />
                          </Box>
                          <Box sx={{ width: "100%" }}>
                            <Typography
                              variant={"body2"}
                              sx={{ color: Colors.black, fontWeight: 600 }}
                            >
                              Check Out Time
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "23px",
                                fontWeight: "bold",
                                mt: "3px",
                              }}
                            >
                              {moment
                                .utc()
                                .startOf("day")
                                .add(
                                  attendanceStatus?.attendanceLog[0]?.check_out,
                                  "minutes"
                                )
                                .format("hh:mm A")}

                              {/* {moment.utc(employeeDetail.time_sheet[employeeDetail.time_sheet.length - 1].checkout).format("hh:mm:ss A")} */}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Grid>
                  )}
                </Grid>
              {/* ) : (
                <Typography
                  variant="body2"
                  sx={{ color: Colors.gray }}
                ></Typography>
              )} */}
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Dialog
    onClick={() => setShowDeviceCheckModal(false)}
      maxWidth="xs"
      open={showDeviceCheckModal}
      sx={{ '& .MuiDialog-paper': {
        boxShadow: 24,
        width: '80%', height: "auto", borderRadius: 2, py: { xs: 2, md: 4 }, px: { xs: 3, md: 6 } } }}
    >
    
      <Box
        sx={{
          // position: 'absolute',
          // top: '50%',
          // left: '50%',
          // transform: 'translate(-50%, -50%)',
          // bgcolor: 'white',
          // borderRadius: 2,
          // p: 4,
          textAlign: 'center',
        }}
      >
        <Typography variant="h6" component="h2" color="error">
          ⚠️ Alert!
        </Typography>
        <Typography sx={{ mt: 2 }}>
        Please use your mobile to Check In and Check Out
        </Typography>
      </Box>

    </Dialog>
    </>
  );
};

export default AnalogClock;
